import React from "react";
import {AButton, ACol, AEmptyState, ARow} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {
  integrationsAdministrationPage,
  newNvmDeviceProfilePage
} from "../../../pages/util/externalLinks";
import css from "./IncidentsLandingPageContent.module.scss";

export default function IncidentsLandingPageContent() {
  const {t} = useTranslation();

  return (
    <ARow
      noGutters
      className={classNames(css.noDataAvailableRow, "justify-center", "py-6")}>
      <ACol className={css.noDataAvailableCol}>
        <AEmptyState variant="positive" large />
      </ACol>
      <ACol className={css.noDataAvailableCol}>
        <h2>{t("incidents.noDataAvailable.title")}</h2>
        <ARow>
          <ACol>{t("incidents.noDataAvailable.subtitle")}</ACol>
        </ARow>
        <ARow>
          <ACol>
            {t("incidents.noDataAvailable.paragraphs.integrationsSetup")}
          </ACol>
        </ARow>
        <ARow>
          <ACol>
            <AButton secondary medium href={integrationsAdministrationPage()}>
              {t("incidents.noDataAvailable.buttons.configureIntegrations")}
            </AButton>
          </ACol>
        </ARow>
        <ARow>
          <ACol>
            {t("incidents.noDataAvailable.paragraphs.nvmConfiguration")}
          </ACol>
        </ARow>
        <ARow>
          <ACol>
            <AButton secondary medium href={newNvmDeviceProfilePage()}>
              {t("incidents.noDataAvailable.buttons.configureNvm")}
            </AButton>
          </ACol>
        </ARow>
      </ACol>
    </ARow>
  );
}
